import Top from '../models/top.es6';
import TopView from '../views/topView.es6';

export default class TopController {
    constructor() {
        this.top = new Top();
        this.topView = new TopView();
    }

    startTopAnimation() {
        this.topView.main.classList.add('-animation');
    }
}
